// OneDrive:IgnoreCodeCoverage

const SUPPORTED_EXTENSIONS = ['.docx', '.xlsx', '.pptx', '.doc', '.xls', '.ppt', '.pdf', '.vsdx', '.vsdm', '.aspx',
  '.vsd', '.vdx', '.vdw', '.vss', '.vssm', '.vssx', '.vst', '.vstm', '.vstx', '.vtx', '.vsx', '.odc', '.ods', '.odt', '.odp'];

export function isSupported(extension: string): boolean {
  return SUPPORTED_EXTENSIONS.indexOf(extension) > -1;
}
